export const BIC_SWIFT_PATTERN = /^[A-Z]{6}[A-Z0-9]{2}([A-Z0-9]{3})?$/;

export const DIGITS_PATTERN = /^[0-9]*$/;

export const LETTERS_NUMBERS_UNDERSCORE_PATTERN = /^[a-zA-Z0-9_]*$/;

export const URL_PATTERN = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=.]+$/;

export const LETTERS_NUMBERS_SPACES_PATTERN = /^[a-zA-Z0-9_ ]*$/;

/** An IPv4 address, with every part between 0 and 255 */
export const IP_V4_PATTERN = /^((25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)\.){3}(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)$/;

/** The check that AngularJS applies to a field of type url: the address needs the scheme (e.g. https://) */
const ANGULAR_URL_PATTERN = /^[a-z][a-z\d.+-]*:\/*(?:[^:@]+(?::[^@]+)?@)?(?:[^\s:/?#]+|\[[a-f\d:]+])(?::\d+)?(?:\/[^?#]*)?(?:\?[^#]*)?(?:#.*)?$/i;

/** An address that has the scheme and also passes `URL_PATTERN`, as in the field of type url of the legacy page */
export const URL_WITH_SCHEME_PATTERN = new RegExp(`^(?=${URL_PATTERN.source})${ANGULAR_URL_PATTERN.source.slice(1)}`, 'i');
